import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Formik } from 'formik';
import { Query, Mutation } from 'react-apollo';
import { gql } from 'apollo-boost';
import CreateStocktakeForm from './createStocktakeForm';
import Spinner from '~/components/spinner/spinner';

export const getTrackedIngredientsQuery = gql`
  query ingredients($breweryId: Int!, $isTracked: Boolean) {
    ingredients(breweryId: $breweryId, isTracked: $isTracked) {
      id
      name
      measurementType
      type
      amountOnHand
    }
  }
`;

export const createStocktakeMutation = gql`
  mutation createStocktake(
    $breweryId: Int!
    $ingredients: [StockAdjustmentIngredient]!
    $notes: String
    $reference: String
  ) {
    createStocktake(breweryId: $breweryId, ingredients: $ingredients, notes: $notes, reference: $reference) {
      id
    }
  }
`;

export class CreateStocktakeModal extends Component {
  state = {
    error: null
  };

  setError = error => {
    this.setState({
      error
    });
  };

  render() {
    const { isOpen, onToggle, brewery, onSuccess } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onToggle} size="lg">
        <ModalHeader toggle={onToggle}>Create new stocktake</ModalHeader>
        <Mutation mutation={createStocktakeMutation} errorPolicy="all">
          {createStocktake => {
            return (
              <Query
                query={getTrackedIngredientsQuery}
                variables={{
                  breweryId: brewery.id,
                  isTracked: true
                }}
                fetchPolicy={'cache-and-network'}
              >
                {props => {
                  const { loading, data } = props;
                  if (loading) {
                    return (
                      <ModalBody>
                        <Spinner className="absolute absolute-center stroke-brand-red" />
                      </ModalBody>
                    );
                  }

                  return (
                    <Formik
                      initialValues={{
                        ingredients: data.ingredients.map(i => ({
                          id: i.id,
                          amount: i.amountOnHand
                        }))
                      }}
                      validateOnChange={false}
                      validateOnBlur={false}
                      render={p => <CreateStocktakeForm ingredients={data.ingredients} {...p} />}
                      onSubmit={async (values, { setErrors, setSubmitting }) => {
                        setSubmitting(true);

                        try {
                          await createStocktake({
                            variables: {
                              breweryId: brewery.id,
                              ...values
                            },
                            awaitRefetchQueries: true,
                            refetchQueries: ['ingredients']
                          });
                          onSuccess();
                        } catch (err) {
                          console.err(err);
                          setErrors({
                            unknown: 'An unknown error occured'
                          });
                          setSubmitting(false);
                        }
                      }}
                    />
                  );
                }}
              </Query>
            );
          }}
        </Mutation>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(CreateStocktakeModal);



// WEBPACK FOOTER //
// ./src/containers/createStocktakeModal/createStocktakeModal.jsx